import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from './cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class AlertasService {
  constructor(private api: CloudFunctionsApiService) {}

  getAlerts() {
    return this.api.snapshotList('/warnings');
  }

  getAlertaById(idAlerta) {
    return this.api.snapshotList(`/warnings/${idAlerta}`);
  }

  getSupervisorAlert(uid) {
    return this.api.snapshotList(`/warnings/user/${uid}`);
  }

  createdAlerta(alert) {
    return this.api.post('/warnings', this.toApiWarning(alert)).toPromise();
  }

  editAlerta(idAlerta, alert) {
    return this.api.patch(`/warnings/${idAlerta}`, this.toApiWarning(alert)).toPromise();
  }

  getAlertaByIdSupervisor(idSupervisor) {
    return this.api.snapshotList(`/warnings/user/${idSupervisor}`);
  }

  getAlertaByIdChat(idChat) {
    return this.api.snapshotList(`/warnings?chatId=${encodeURIComponent(idChat)}`);
  }

  deleteAlert(idAlerta) {
    return this.api.delete(`/warnings/${idAlerta}`).toPromise();
  }

  getAlertaByMensajeAndName(mensaje, idUsuario, fecha) {
    return this.api.snapshotList(
      `/warnings?message=${encodeURIComponent(mensaje)}&userId=${encodeURIComponent(idUsuario)}&date=${encodeURIComponent(fecha)}`
    );
  }

  private toApiWarning(warning: any) {
    return {
      ...warning,
      avatarColegio: warning?.schoolAvatar || warning?.avatarColegio || '',
      estado: warning?.status || warning?.estado || '',
      fechaAlerta: warning?.alertDate || warning?.fechaAlerta || new Date(),
      idAlerta: warning?.alertId || warning?.idAlerta,
      idChat: warning?.chatId || warning?.idChat,
      idColegio: warning?.schoolId || warning?.idColegio || '',
      idSupervisor: warning?.supervisorId || warning?.idSupervisor || '',
      idUsuario: warning?.userId || warning?.idUsuario || '',
      mensaje: warning?.message || warning?.mensaje || '',
      mostrarSupervisor:
        typeof warning?.showSupervisor === 'boolean'
          ? warning.showSupervisor
          : warning?.mostrarSupervisor,
      avatarAlumno: warning?.studentAvatar || warning?.avatarAlumno || '',
      reportada:
        typeof warning?.reported === 'boolean' ? warning.reported : warning?.reportada,
      nombre: warning?.name || warning?.nombre || '',
      resumen: warning?.summary || warning?.resumen || '',
      severidad: warning?.severity || warning?.severidad || '',
    };
  }
}
